import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RichsnipetService } from 'dmmp-services'

@Component({
  selector: 'dmmp-website-header',
  templateUrl: './website-header.component.html',
})
export class WebsiteHeaderComponent {
  @Input() identifier
  @Input() data: any
  @Input() menu: any
  @Input() world_search = ''
  @Input() endPoint
  @Output() searching = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  classMenu = 'empty'
  contentSearch
  showSearchContent = false
  showSearchContentMenu = false

  constructor(public richsnipetService: RichsnipetService) {}

  ancla(event, data) {
    if (data.indexOf('#') === 0 && data?.length > 1) {
      this.anchorCustom.emit({event: event, id: data})
    }
  }

  open() {
    this.showSearchContent = false
    if (this.classMenu === 'empty') {
      this.classMenu = 'show'
      this.showSearchContentMenu = true
    } else {
      this.classMenu = 'empty'
      this.showSearchContentMenu = false
    }
  }

  showSearch(placeholder: string, image) {
    this.classMenu = 'empty'
    this.showSearchContentMenu = false
    this.showSearchContent = !this.showSearchContent
    this.contentSearch = { placeholder: placeholder, image: image }
  }

  closeMenu() {
    this.classMenu = 'empty'
    this.showSearchContent = false
    this.showSearchContentMenu = false
  }
}
